// IE 2026 10 11 / ODOO-345618: выбор значения ссылочной ячейки грида (AttrLink → USER и т.п., режим «Edit in a grid») из списка сегмента.
// Чистые функции без DOM — покрыты tests/unit/gridPicker.test.mjs.

// Действие клика по подвалу выпадашки (Dropdown.onFooter_Click):
// - 'more'     — справочник выдан не целиком («N more options»): прежнее поведение, список выбора (onMore) с набранным текстом;
// - 'pick'     — подвал «Open list» при флаге fe.ux.openListAsPicker (дефолт ВКЛ) и заданном onMore: список сегмента в режиме ВЫБОРА (isChoise,
//                кнопка Choice возвращает значение в ячейку) — тот же путь, что значок ☰ (onListButton_Click);
// - 'openList' — флаг выключен / onMore не задан: прежнее поведение — список сегмента отдельным виджетом, без выбора (onOpenListItemsSource__Click);
// - null       — подвала нет.
export function dropdownFooter_action({ moreCount = 0, canLoadFull = false, showList = false, hasOnMore = false, openListAsPicker = true } = {}) {
    if (moreCount > 0 || canLoadFull) return 'more'
    if (!showList) return null
    if (openListAsPicker !== false && hasOnMore) return 'pick'
    return 'openList'
}

// Подпись (title) подвала «Open list» по реальному действию: 'pick' — выбор из списка; 'openList' — список отдельным виджетом.
// Возвращает ключ i18n (английский текст) или '' — подписи нет.
export function dropdownFooter_titleKey(action) {
    if (action === 'pick') return 'Choose from list'
    if (action === 'openList') return 'Open the list in a separate widget (no choice)'
    return ''
}

// Двойной клик по строке грида-списка, открытого для ВЫБОРА (WIDGET.parentAction.params.isChoise, AttrGrid.execute_dblclick без force):
// при флаге fe.ux.pickerDblClick (дефолт ВКЛ) = выделить строку + команда Choice (dblclick_action бэка: command 'onChoice', dblClick).
// Вне режима выбора, по заголовку колонки / пустому месту, при выключенном флаге — прежнее поведение (нативный dblclick ничего не делает).
export function picker_dblClickChooses({ pickerDblClick = true, isChoise = false, action = null, isDataRow = false } = {}) {
    if (pickerDblClick === false) return false
    if (!isChoise || !isDataRow) return false
    return !!action && action.command === 'onChoice'
}

// IE 2026 10 11 / ODOO-345618: свой детектор двойного клика для списка выбора. В закреплённой (frozen) колонке Title wijmo после первого клика
// перерисовывает ячейку (клон frozen-ячеек), второй mousedown/click приходит уже на другой элемент, и браузер НЕ генерирует dblclick
// (замер на dev02: по Title приходят mousedown/click ×2 без dblclick, по Email — полный набор). Два клика подряд рядом по времени и месту = двойной.
// prev/cur: { t (мс), x, y, button }; возвращает true, если cur завершает двойной клик. Порог времени и сдвига — как у браузера по умолчанию.
export function picker_isDoubleClick(prev, cur, { maxMs = 500, maxPx = 5 } = {}) {
    if (!prev || !cur) return false
    if (prev.button !== 0 || cur.button !== 0) return false
    const dt = cur.t - prev.t
    if (!(dt >= 0 && dt <= maxMs)) return false
    return Math.abs(cur.x - prev.x) <= maxPx && Math.abs(cur.y - prev.y) <= maxPx
}

// Обработчик click хоста грида списка выбора: возвращает { chosen, last }. chosen — этот клик закрыл двойной клик, и нативный dblclick
// ещё не отработал (recentChoiceAt — время последнего Choice по dblclick, защита от двойного выполнения при нативном dblclick в тот же жест).
// Вне режима выбора / при выключенном флаге — chosen=false и last=null (состояние не копится).
export function picker_clickStep({ pickerDblClick = true, isChoise = false, last = null, cur = null, recentChoiceAt = 0 } = {}) {
    if (pickerDblClick === false || !isChoise || !cur) return { chosen: false, last: null }
    if (recentChoiceAt && cur.t - recentChoiceAt >= 0 && cur.t - recentChoiceAt <= 800) return { chosen: false, last: null }
    if (picker_isDoubleClick(last, cur)) return { chosen: true, last: null }
    return { chosen: false, last: cur }
}
